import { produce } from 'immer'
import type { State } from '../../typings'
import { CustomerInfo } from './typings'

export function setCustomerProducer(
  state: State,
  payload: CustomerInfo,
): State {
  return produce(state, (draft) => {
    draft.referralCustomerId = payload.referralCustomerId
    draft.referralCustomerIdTemp = payload.referralCustomerId
    draft.referralLocationCode = payload.referralLocationCode
  })
}
